import CryptoJS from 'crypto-js'

export function calculateObjectHash(object: Record<string | number | symbol, any>): string {
  const jsonString = JSON.stringify(object)
  return CryptoJS.MD5(jsonString).toString()
}

export function generateUniqueId() {
  return Date.now().toString(36) + Math.random().toString(36).substring(2)
}
